<template>
  <v-container fluid align-start ma-0 pa-2 class="container-height">
    <v-row no-gutters fill-height>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle"
                         :class="[setBtnColor]"
                         :useBtnList="useBtnList"
                         @btnRetrieve="btnRetrieve()" 
                         @btnPrint="btnPrint()" 
                         @btnMakeRequest="btnMakeRequest()"
                         @btnUpdate="btnUpdate()"
                         @btnDelete="btnDelete()" 
                         @btnOutsideInsp="btnOutsideInsp()">
          <template v-slot:body>
            <v-row>
              <v-col cols="12" class="pa-0">
                <i-card-top class="d-md-flex" outlined>
                  <template v-slot:body>
                    <v-row no-gutters class="center pa-0 pl-1">
                      <v-col cols="12">
                        <v-row dense>
                          <i-label :label="'Supplier name : '" />
                          <v-col cols="4">
                            <v-select 
                              v-model="supName" 
                              :items="supNameList" 
                              item-value="supName" 
                              return-object 
                              single-line 
                              outlined 
                              dense 
                              @change="supNameChange">
                            </v-select>
                          </v-col>
                          <v-col cols="full" align="right">
                            <span class="pa-2" style="background-color: #00FF00; font-weight: bold;">None Official</span>
                          </v-col>
                        </v-row>
                        <v-row dense class="ma-0">
                          <i-label :label="'Division : '" />
                          <v-col cols="1">
                            <v-select 
                              v-model="division" 
                              :items="divisionList" 
                              item-value="code"
                              item-text="codeName"
                              return-object 
                              single-line 
                              outlined 
                              dense>
                            </v-select>
                          </v-col>
                          <v-col cols="2" class="pl-0">
                            <DxDateBox 
                              :value="stDate" 
                              height="30px" 
                              display-format="yyyy-MM-dd" 
                              :acceptCustomValue="false" 
                              outlined 
                              dense
                              @value-changed="e => {reqDtFrom = e.value && getStrFormat(e.value)}" />
                          </v-col>
                          <i-label :label="'Ship No : '" class="pl-2" />
                          <v-col cols="1">
                            <v-select 
                              v-model="shipNo" 
                              :items="shipNoList" 
                              item-value="shipNo" 
                              return-object 
                              single-line 
                              outlined 
                              dense>
                            </v-select>
                          </v-col>
                          <i-label :label="'Block No : '" class="pl-2" />
                          <v-col cols="1">
                            <v-text-field 
                              dense 
                              outlined 
                              hide-details="auto" 
                              clearable maxLength="4" 
                              v-model="blockNo"  
                              @keyup="uppercase"
                              v-on:keyup.enter="btnRetrieve"
                              />
                          </v-col>
                          <i-label :label="'QM Part : '" class="pl-2" />
                          <v-col cols="1">
                            <v-select 
                              v-model="qmPart" 
                              :items="qmPartList" 
                              item-value="qmPart" 
                              return-object 
                              single-line 
                              outlined 
                              dense 
                              @change="btnRetrieve">
                            </v-select>
                          </v-col>
                          <i-label :label="'Inspection Kind : '" class="pl-2" />
                          <v-col cols="1">
                            <v-select
                              v-model="inspection" 
                              :items="inspectionList" 
                              item-value="inspection" 
                              return-object 
                              single-line 
                              outlined 
                              dense 
                              @change="btnRetrieve">
                            </v-select>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </template>
                </i-card-top>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="12" class="pt-1">                
                <DxDataGrid 
                  id="requestList" 
                  :ref="requestListRef" 
                  class="listBox04"
                  :data-source="gridMainList" 
                  :remote-operations="false" 
                  :hover-state-enabled="true" 
                  :allow-column-resizing="true" 
                  :allow-column-reordering="true" 
                  :row-alternation-enabled="true" 
                  :show-borders="true" 
                  :width="grid.width" 
                  :show-row-lines="true" 
                  key-expr="id" 
                  :focused-row-enabled="false" 
                  :column-hiding-enabled="false" 
                  :sorting="{ mode: 'none' }" 
                  :selection="{ mode: 'none' }" 
                  :word-wrap-enabled="true" 
                  @cellPrepared="cellPrepared" 
                  @editing-start="onEditingStart">

                  <DxColumn data-field="selChek" caption="Sel" data-type="boolean" width="2%" cell-template="selChkRow" :allow-editing="false" />
                  <template #selChkRow="{ data: cellInfo }">
                    <DxCheckBox 
                    :value="cellInfo.value == 'Y' ? true : false" 
                    :disabled="cellInfo.data.resYn === 'Y' ? true : false" 
                    :onValueChanged="value => onValueChanged(value, cellInfo)" />
                  </template>

                  <DxColumn caption="Req. Date" data-type="date" alignment="center" format="yyyy-MM-dd" :allow-editing="true">
                    <DxColumn data-field="reqDate" caption="Ins. Date" width="7%" data-type="date" format="yyyy-MM-dd" alignment="center" :allow-editing="true" />
                  </DxColumn>

                  <DxColumn caption="Req. Time" data-type="string" alignment="center" :allow-editing="true">
                    <DxColumn data-field="reqTime" caption="Ins. Time" width="7%" data-type="string" alignment="center" :allow-editing="true">
                      <DxLookup :data-source="insTimeList" display-expr="timeNm" value-expr="codeName" />
                    </DxColumn>
                  </DxColumn>
                  <DxColumn data-field="shipNo" caption="Ship No" width="6%" data-type="string" alignment="center" :allow-editing="false" />
                  <DxColumn data-field="block" caption="Block" width="6%" data-type="string" alignment="center" :allow-editing="false" />                  
                  <DxColumn caption="POR" data-type="string" alignment="center" :allow-editing="false">
                    <DxColumn data-field="porNo" caption="Seq" width="3%" data-type="string" alignment="center" :allow-editing="false" />
                  </DxColumn>
                  <!-- <DxColumn caption="Inspection Item" data-type="string" alignment="left" :allow-editing="true">
                      <DxColumn data-field="inspAct" caption="Remark" width="31%" data-type="string" alignment="left" :allow-editing="true" />
                  </DxColumn> -->
                  <DxColumn caption="Inspection Item" data-type="string" alignment="left" :allow-editing="true">
                    <DxColumn data-field="itemDesc" caption="Remark" width="31%" data-type="string" alignment="left" :allow-editing="true" />
                  </DxColumn>
                  <DxColumn data-field="controlFile" caption="Control file" width="10%" data-type="string" alignment="center" cell-template="controlFile" :allow-editing="false" />
                  <template #controlFile="{ data }">
                    <div>
                      <div :style="data.text === '' ? '' : 'display: none'">
                        <v-btn small elevation="0" color="transparent" class="px-1 py-0 receiptBtn" @click="fileOpen(data)">
                          Open
                          <v-icon small class="mt-n1" color="blue">
                            mdi-folder
                          </v-icon>
                        </v-btn>
                      </div>
                      <div :style="data.text === '' ? 'display: none' : ''">
                        <span>{{ data.text }} file(s)</span>
                      </div>
                    </div>
                  </template>

                  <DxColumn caption="LQC Member" data-type="string" alignment="center" :allow-editing="true">
                    <DxColumn data-field="lqcMember" caption="Inspection Kind" width="5%" data-type="string" alignment="center" :allow-editing="true">
                      <DxLookup :data-source="lqcMemberList" display-expr="enm" value-expr="empNo" />
                    </DxColumn>
                  </DxColumn>

                  <DxColumn caption="LQC Member" data-type="string" alignment="center" :allow-editing="true">
                    <DxColumn data-field="lqcMember2" caption="Inspection Kind" width="5%" data-type="string" alignment="center" :allow-editing="true" />
                  </DxColumn>

                  <DxColumn caption="NDT" data-type="boolean" alignment="center" :allow-editing="false">
                    <DxColumn data-field="ndtChk" caption="DMT" width="4%" data-type="boolean" alignment="center" :allow-editing="false" edit-cell-template="ndtChk" />
                  </DxColumn>
                  <DxColumn caption="LQ" data-type="boolean" alignment="center" :allow-editing="false">
                    <DxColumn data-field="wlq" caption="Result" width="4%" data-type="boolean" alignment="center" :allow-editing="false" edit-cell-template="wlqChk" />
                  </DxColumn>
                  <DxColumn caption="QM" data-type="boolean" alignment="center" :allow-editing="false">
                    <DxColumn data-field="wqm" caption="Result" width="4%" data-type="boolean" alignment="center" :allow-editing="false" edit-cell-template="wqmChk" />
                  </DxColumn>
                  <DxColumn caption="OW" data-type="boolean" alignment="center" :allow-editing="false">
                    <DxColumn data-field="wow" caption="Result" width="4%" data-type="boolean" alignment="center" :allow-editing="false" edit-cell-template="wowChk" />
                  </DxColumn>
                  <DxColumn caption="CL" data-type="boolean" alignment="center" :allow-editing="false">
                    <DxColumn data-field="wcl" caption="Result" width="4%" data-type="boolean" alignment="center" :allow-editing="false" edit-cell-template="wclChk" />
                  </DxColumn>
                  <DxColumn caption="EQ" data-type="boolean" alignment="center" :allow-editing="false">
                    <DxColumn data-field="eqYn" caption="Result" width="4%" data-type="boolean" alignment="center" :allow-editing="false" edit-cell-template="eqChk" />
                  </DxColumn>

                  <template #ndtChk="{ data: cellInfo }">
                    <DxCheckBox :value="cellInfo.value == 'Y' ? true : false" :disabled="cellInfo.data.resYn === 'Y' ? true : false" :onValueChanged="value => onValueChanged2(value, cellInfo)" />
                  </template>
                  <template #wlqChk="{ data: cellInfo }">
                    <div :style="cellInfo.value === 'Y' || cellInfo.value === 'N' ? '' : 'display: none'">
                      <DxCheckBox :value="cellInfo.value == 'Y' ? true : false" :disabled="cellInfo.data.resYn === 'Y' ? true : false" :onValueChanged="value => onValueChanged2(value, cellInfo)" />
                    </div>
                  </template>
                  <template #wqmChk="{ data: cellInfo }">
                    <div :style="cellInfo.value === 'Y' || cellInfo.value === 'N' ? '' : 'display: none'">
                      <DxCheckBox :value="cellInfo.value == 'Y' ? true : false" :disabled="cellInfo.data.resYn === 'Y' ? true : false" :onValueChanged="value => onValueChanged2(value, cellInfo)" />
                    </div>
                  </template>
                  <template #wowChk="{ data: cellInfo }">
                    <div :style="cellInfo.value === 'Y' || cellInfo.value === 'N' ? '' : 'display: none'">
                      <DxCheckBox :value="cellInfo.value == 'Y' ? true : false" :disabled="cellInfo.data.resYn === 'Y' ? true : false" :onValueChanged="value => onValueChanged2(value, cellInfo)" />
                    </div>
                  </template>
                  <template #wclChk="{ data: cellInfo }">
                    <div :style="cellInfo.value === 'Y' || cellInfo.value === 'N' ? '' : 'display: none'">
                      <DxCheckBox :value="cellInfo.value == 'Y' ? true : false" :disabled="cellInfo.data.resYn === 'Y' ? true : false" :onValueChanged="value => onValueChanged2(value, cellInfo)" />
                    </div>
                  </template>
                  <template #eqChk="{ data: cellInfo }">
                    <div :style="cellInfo.value === 'Y' || cellInfo.value === 'N' ? '' : 'display: none'">
                      <DxCheckBox :value="cellInfo.value == 'Y' ? true : false" :disabled="cellInfo.data.resYn === 'Y' ? true : false" :onValueChanged="value => onValueChanged2(value, cellInfo)" />
                    </div>
                  </template>

                  <DxPaging :enabled="true" :page-size="12" />
                  <DxPager :visible="true" :showInfo="false" />
                </DxDataGrid>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12">
                <v-row no-gutters>
                  <v-col cols="12" class="subText">Count Total: {{ listSize }} Row(s)</v-col>
                </v-row>
                <!-- <v-row no-gutters>
                  <v-col cols="3" class="subText">AA : Accept</v-col>
                  <v-col cols="4" class="subText">PA : Cancel due to Bad weather</v-col>
                  <v-col cols="3" class="subText">RA : Reject due to bad work</v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="3" class="subText">AC : Confirm by QM</v-col>
                  <v-col cols="4" class="subText">CA : Canceled by pro dep't</v-col>
                  <v-col cols="3" class="subText">RB : Safety problem</v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="3" class="subText">AD : Confirmed by OW/CL (Pro dept)</v-col>
                  <v-col cols="4" class="subText">CB : Canceled by after confirmed by QM</v-col>
                  <v-col cols="3" class="subText">RC : Not finished work</v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="3" class="subText">AE : Confirmed by OW/CL (Others dept)</v-col>
                  <v-col cols="4" class="subText">PD : Canceled due to OW/CL inspection at another location</v-col>
                  <v-col cols="3" class="subText">RD : Process is interrupted</v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="3" class="subText">LQ : Confirmed by Maker</v-col>
                  <v-col cols="4" class="subText">PE : Canceled due to another process is interrupted</v-col>
                  <v-col cols="3" class="subText">RE : Not yet cleaning</v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="3" class="subText">PM : Cancelled during meeting with Owner</v-col>
                  <v-col cols="4" class="subText">PF : Canceled due to OW/CL not understand</v-col>
                  <v-col cols="3" class="subText">RF : Another</v-col>
                </v-row> -->
              </v-col>
            </v-row>

          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
    <v80a1040Pop :showPop.sync="showPop" :popupData="popupData" @fileSave="btnRetrieve($event)" />
    <!--v80a1040MakePop v-if="makePop" :makePop.sync="makePop" :makePopData="makePopData" :supNameList="supNameList" :qmPartList="qmPartList" :inspectionList="inspectionList" :insTimeListPop="insTimeList" :lqcMemberListPop="lqcMemberList" :inspLocListPop="inspLocList" :kindInspListPop="kindInspList" @isSaved="request($event)" /-->
    <v80a1040MakePop :makePop.sync="makePop" :makePopData="makePopData" :supNameList="supNameList" :qmPartList="qmPartList" :inspectionList="inspectionList" :insTimeListPop="insTimeList" :lqcMemberListPop="lqcMemberList" :inspLocListPop="inspLocList" :kindInspListPop="kindInspList" @isSaved="request($event)" />
  </v-container>
</template>

<script>
import {
  DxDataGrid,
  DxEditing,
  DxColumn,
  DxLookup,
  DxSelection,
  DxPager
} from 'devextreme-vue/data-grid'
import DxDateBox from 'devextreme-vue/date-box'
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import {
  getSupplier,
  getV80ShipNo,
  v80a1040List,
  getRespMaker,
  getLqcMember,
  v80a1040Update,
  v80a1040Delete
} from '@/api/view/hip/8/v80a1040.js'
import {
  reportView
} from '@/api/view/hip/common/common.js'
import {
  getCmChildCode
} from '@/api/system/cmCodeManage'
import v80a1040Pop from '@/views/hip/8/popup/v80a1040Pop'
import v80a1040MakePop from '@/views/hip/8/popup/v80a1040MakePop'
import {
  getDateFormat,
  getCurrentDate
} from '@/utils/common.js'
import dayjs from 'dayjs';
import notify from 'devextreme/ui/notify' // message

export default {
  name: 'v80a1040',
  mixins: [baseview, BaseDataGrid],
  components: {
    ICardVertical,
    "i-card-top": iCardTop,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxDateBox,
    DxLookup,
    v80a1040Pop,
    v80a1040MakePop,
    DxSelection,
    DxPager
  },
  data() {
    return {
      menuTitle: this.$route.meta.title,
      useBtnList: ['btnRetrieve', 'btnMakeRequest', 'btnUpdate', 'btnDelete', 'btnPrint', 'btnOutsideInsp'],
      requestListRef: 'requestListRef',
      gridMainList: [],
      setBtnColor: 'setBtnColor',

      stDate: '',

      supName: '',
      supNameList: [],
      division: '',
      divisionList: [],
      shipNo: '',
      shipNoList: [],
      blockNo: '',
      qmPart: '',
      qmPartList: [],
      inspection: '',
      inspectionList: [],

      custCd: '',
      respCd: '',

      listSize: 0,

      insTimeList: [],
      lqcMemberList: [],
      inspLocList: [],

      showPop: false,
      popupData: [],

      makePop: false,
      makePopData: [],

      kindInspList: [],

    }
  },
  computed: {
    gridMainInstance() {
      return this.GetDataGrid(this.requestListRef)
    },

  },
  beforeMount() {
    //inspTimeList
    let params = {
      makerCd: this.$store.state.user.makerCd,
      code: '',
      codegr: '',
      prtCode: 'TIME_INSP',
      userFlag: 'Y',
    }
    Promise.all([
      getCmChildCode(params)
    ]).then(res => {
      res[0].list.forEach(e => {
        if (e.codeName != null) {
          e.timeNm = e.codeName.substring(0, 2) + ':' + e.codeName.substring(2)
        } else {
          e.timeNm = ''
        }
      });
      this.insTimeList = res[0].list
    }).catch(error => {})

  },
  mounted() {
    this.init()
    this.gridMainInstance.option('defaultPaging', false)
  },
  methods: {
    getStrFormat(date) {
      this.stDate = getDateFormat(date)
      return getDateFormat(date)
    },
    init() {
      let toDay = new Date
      toDay.setDate(toDay.getDate() + 1);
      this.stDate = toDay

      this.getList()

      if (this.$store.state.user.userGrd !== 'A') {
        this.supNameChange()
      } 

    },

    fileSave(e){
      // this.shipNo = ''
      this.shipNo = e.shipNo
      this.custCd = e.makerCd
      // this.inspDiv = e.inspDiv
      this.stDate = e.reqDate
      // this.qmPart = e.qmPart
      // this.resultInsp = e.insRes
      // this.inspKind = e.kindCd

      this.getMainList()
    },

    async getList() {
      try {
        this.openLoading('searching')
        let params = {
          // makerCd: this.$store.state.user.userGrd !== 'A' ? this.custCd : '%',
          makerCd: this.$store.state.user.userGrd !== 'A' ? this.$store.state.user.makerCd : '%',
          porDiv: 'N',
          code: '',
          codegr: '',
          prtCode: 'INSP_DIV',
          userFlag: 'Y',
          shipGu: ''
        }
        let params2 = {
          code: '',
          codegr: '',
          prtCode: 'QC_PART',
          userFlag: 'Y'
        }
        let params3 = {
          code: '',
          codegr: '',
          prtCode: 'KIND_CD',
          userFlag: 'Y'
        }
        let params4 = {
          code: '',
          codegr: '',
          prtCode: 'INSP_LOC',
          userFlag: 'Y'
        }

        await getSupplier(params).then(res => {
          // this.supNameList.push('Select Supplier')
          if (this.$store.state.user.userGrd == 'A') {
            this.supNameList.push('Select Supplier')
          }   
          res.list.forEach(e => {
            this.supNameList.push(e.custCd + ' : ' + e.custNm)
          });
          this.supName = this.supNameList[0]
        })

        await getCmChildCode(params).then(res => {
          res.list.forEach(e => {
            this.divisionList.push(e)//e.codeName
          });
          this.division = this.divisionList[0]
        })

        getV80ShipNo(params).then(res => {
          this.shipNoList.push('All')
          res.list.forEach(e => {
            this.shipNoList.push(e.shipNo)
          });
          this.shipNo = this.shipNoList[0]
        })

        getCmChildCode(params2).then(res => {
          res.list.forEach(e => {
            this.qmPartList.push(e.codeName)
          });
          this.qmPart = this.qmPartList[0]
        })

        getCmChildCode(params3).then(res => {
          this.inspectionList.push('Select...')
          res.list.forEach(e => {
            this.inspectionList.push(e.codeName)
          });
          this.kindInspList = res.list
          this.inspection = this.inspectionList[0]
        })

        getCmChildCode(params4).then(res => {
          this.inspLocList = res.list
        })

      } finally {
        this.endLoading()
      }
    },
    async getMainList() {
      try {
        this.openLoading('searching')
        let kindCd = ''
        switch (this.inspection) {
          case 'Select...':
            kindCd = '%'
            break
          case 'Final Inspection':
            kindCd = 'FIN'
            break
          case 'Filler Air Test':
            kindCd = 'AIT'
            break
          case 'QM Inspection':
            kindCd = 'INS'
            break
          case 'Dimension check':
            kindCd = 'DIM'
            break
          case 'Installation & Function inspection':
            kindCd = 'IFU'
            break  
        }

        let params = {
  
          shipNo: this.shipNo == 'All' ? '' : this.shipNo,
          makerCd: this.custCd,
          inspDiv: !this.division.code ? '' : this.division.code,
          stDate: this.stDate,
          qcPart: this.qmPart == 'Hull' ? 'H' : 'M',
          block: !this.blockNo ? '' : this.blockNo,
          kindCd: kindCd,
          respCd: this.respCd
        }

        // console.log('params', params)
        await v80a1040List(params).then(res => {
          let list = []
          let cnt = 1;
          let num = 1;
          res.list.forEach(e => {
            list.push({
              id: cnt++,
              reqDate: e.reqDate,
              reqTime: e.reqTime,
              shipNo: e.shipNo,
              block: e.block,
              porNo: e.porNo,
              // inspAct: e.inspAct
              itemDesc: e.itemDesc,
              controlFile: '',
              // lqcMember: '',
              lqcMember: e.lqcEmp,
              lqcMember2: '',
              ndtChk: e.ndtChk,
              wlq: e.wlq,
              wqm: e.wqm,
              wow: e.wow,
              wcl: e.wcl,              
              eqYn: e.eqYn,
              selChk: 'N',
              qmYn: e.qmYn,
              resYn: e.resYn,
              revNo: e.revNo,
              num: num++,
              selChek: 'N',
              insRes: e.insRes,
              inspAct: e.inspAct,
              insDate: e.insDate,
              insTime: e.insTime,
              dimtYn: e.ndtChk,
              remark: e.remark
            }, {
              id: cnt++,
              reqDate: e.insDate,
              reqTime: e.insTime,
              shipNo: e.shipNo,
              block: e.block,
              porNo: e.porSeq,
              // inspAct: e.inspAct,
              itemDesc: e.remark,
              controlFile: e.cntFile,
              lqcMember: e.kindNm,
              lqcMember2: e.kindNm,
              ndtChk: e.dimtYn,
              wlq: e.insRes,
              wqm: e.insRes,
              wow: e.insRes,
              wcl: e.insRes,              
              eqYn: e.insRes,
              selChk: 'N',
              qmYn: e.qmYn,
              resYn: e.resYn,
              revNo: e.revNo,
              num: num++,
              selChek: 'N',
              insRes: e.insRes,
              inspAct: e.inspAct
            }, )
          });

          this.gridMainList = list
          this.listSize = res.list.length
        })

      } finally {
        this.endLoading()
      }
    },
    supNameChange() {
      let supNameGbn = this.supName
      supNameGbn = supNameGbn.split(' : ')
      this.custCd = supNameGbn[0]

      let params = {
        makerCd: this.custCd
      }

      /* If (this.$store.state.user.userGrd !== 'A' )
        getRespMaker(params).then(res => {
            this.respCd = res.list[0].respCd
      })
 */
      getLqcMember(params).then(res => {
        this.lqcMemberList = res.list
      })

      if (this.$store.state.user.userGrd !== 'A') {
        this.custCd = this.$store.state.user.makerCd 

        let params = {
            makerCd: this.$store.state.user.makerCd 
        }

        getRespMaker(params).then(res => {
          this.respCd = res.list[0].respCd
        })

        getLqcMember(params).then(res => {
          this.lqcMemberList = res.list
        })

      } else {        
        let params = {
            makerCd: this.custCd
        }

        getRespMaker(params).then(res => {
          this.respCd = res.list[0].respCd
        })

        /* getLqcMember(params).then(res => {
          this.lqcMemberList = res.list
        }) */
        
      } 

      // this.btnRetrieve()
    },
    uppercase() {
      // if (!this.blockNo) {
        this.blockNo = this.blockNo.toUpperCase()
      // }
    },
    btnRetrieve() {
      if (!this.custCd) {
        this.vToastify(this.$t('Please, Select Supplier to Retrieve!'), 'warn')
        return
      }
      if (this.custCd === '14017' || this.custCd === '12994') {
        this.gridMainList = []
        this.getMainList()
      } else {
        this.vToastify(this.$t('Sorry!, The Supplier cannot apply for this program!'), 'warn')
        return
      }
    },
    btnMakeRequest() {
      if (!this.custCd) {
        this.vToastify(this.$t('Please, select a Sub-Contract!!'), 'warn')
        return
      }
      if (this.shipNo === null || this.shipNo === 'All') {
        this.vToastify(this.$t('Please, select a Ship No!!'), 'warn')
        return
      }
      if (!this.qmPart) {
        this.vToastify(this.$t('Please, select a QM Part!!'), 'warn')
        return
      }

      // if (this.custCd === '14017' || this.custCd === '12994') {
        this.makePopData.custCd = this.custCd
        this.makePopData.shipNo = this.shipNo
        this.makePopData.qmPart = this.qmPart
        this.makePopData.stDate = this.stDate
        this.makePopData.inspDiv = !this.division.code ? '' : this.division.code,//this.division

        this.makePop = true
      // } else {
      //   this.vToastify(this.$t('Sorry!, This Supplier cannot make application!'), 'warn')
      //   return
      // }
    },
    async btnUpdate() {
      if (this.gridMainList.length > 0) {
        await this.gridMainInstance.saveEditData()
        var selectedMainRows = await this.gridMainInstance.getSelectedRowsData()
        let params = []
        let toDay = new Date()
        toDay.setDate(toDay.getDate() + 1);
        toDay = dayjs(toDay).format('YYYY-MM-DD')

        if (!selectedMainRows.length) {
          this.vToastify(this.$t('Data is not selected.'), 'warn')
          return
        }
        for(let i = 0; i < selectedMainRows.length; i++) {
          if (selectedMainRows[i].id % 2 != 0) {
            let list = selectedMainRows[i]
            if (!selectedMainRows[i+1].reqDate) {
              this.vToastify(this.$t('Select Inspection Date.'), 'warn')
              return
            }
            if (!selectedMainRows[i+1].reqTime) {
              this.vToastify(this.$t('Select Inspection Time.'), 'warn')
              return
            }
            if (selectedMainRows[i+1].reqDate < toDay) {
              this.vToastify(this.$t('You cannot request the inspection of this day. You select Inspection Date over today please!'), 'warn')
              return
            }
            if (list.wqm !== 'Y' && list.wow !== 'Y' && list.wcl !== 'Y') {
              this.vToastify(this.$t('Please, check box for Withness plan(OW/CL)!'), 'warn')
              return
            }
            params.push({
              reqDate: list.reqDate,              
              insDate: dayjs(selectedMainRows[i+1].reqDate).format('YYYY-MM-DD'),
              reqTime: list.reqTime,
              insTime: selectedMainRows[i+1].reqTime,
              shipNo: list.shipNo,
              respCd: this.respCd,
              inspAct: list.inspAct,
              wqm: list.wqm,
              wow: list.wow,
              wcl: list.wcl,
              ndtChk: list.ndtChk,
              eqYn: list.eqYn,
              dimtYn: selectedMainRows[i+1].ndtChk,
              remark: selectedMainRows[i+1].itemDesc,
              itemDiv: this.qmPart == 'Hull' ? 'H' : 'M',
              userId: this.custCd,
              empNo: list.lqcMember,
              revNo: list.revNo
            })
          }
        }

        // console.log('Update :', params);
        this.openLoading('searching')
        v80a1040Update(params).then(res => {
          if (res.body === 'Y') {
            notify(this.$t('Request is Update completed.'), 'success', 3000)
          } else {
            this.vToastify(this.$t('An error was occured :' + res.body), 'warn')
          }
        })
            .catch(error => {
              this.vToastify(error, 'warn')
            })
            .finally(() => {
              this.gridMainInstance.clearSelection()
              this.btnRetrieve()
            })
      }
    },
    async btnDelete() {
      if (this.gridMainList.length > 0) {
        await this.gridMainInstance.saveEditData()
        var selectedMainRows = await this.gridMainInstance.getSelectedRowsData()
        let params = []

        if (!selectedMainRows.length) {
          this.vToastify(this.$t('Data is not selected.'), 'warn')
          return
        }

        for (let i = 0; i < selectedMainRows.length; i++) {
          if (selectedMainRows[i].id % 2 != 0) {
            let list = selectedMainRows[i]

            if (Number(selectedMainRows[i+1].controlFile) > 0) {
              this.vToastify(this.$t('Some Item inspection already exists attachment file! You must Delete attach file the first!'), 'warn')
              return
            }
            params.push({
              reqDate: list.reqDate,
              shipNo: list.shipNo,
              respCd: this.respCd,
              inspAct: list.inspAct,
              revNo: list.revNo,
              insRes: !list.insRes ? '' : list.insRes

            })
          }
        }

        // console.log("params", params)
        
        try {
          this.openLoading('searching')

          this.vToastifyPrompt(
              this.$t('Do you want to delete the data?'),
              'info',
              async current => {
                // console.log("yes", params)
                v80a1040Delete(params).then(res => {
                  if (res.body === 'OK') {
                    notify(this.$t('Deleting is completed.'), 'success', 3000)
                  } else {
                    this.vToastify(this.$t('An error has been occurred while deleting data.'), 'warn')
                    // notify(this.$t('An error has been occurred while deleting data.'), 'error', 3000)
                  }
                })
                .catch(error => {
                  //this.vToastify(error, 'warn')
                  notify(this.$t(error), 'error', 3000)
                })
                .finally(() => {
                  this.gridMainInstance.clearSelection()
                  this.btnRetrieve()
                })
              }
              , null,
              true
          )
        } finally {
         this.endLoading()
        }
      }
    },
    btnPrint() {
      let kindCd = ''
      switch (this.inspection) {
        case 'Select...':
          kindCd = '%'
          break
        case 'Final Inspection':
          kindCd = 'FIN'
          break
        case 'Filler Air Test':
          kindCd = 'AIT'
          break
        case 'QM Inspection':
          kindCd = 'INS'
          break
        case 'Dimension check':
          kindCd = 'DIM'
          break
        case 'Installation & Function inspection':
          kindCd = 'IFU'
          break   
      }

      if (!this.custCd) {
        this.vToastify(this.$t('Please, Select Supplier to Retrieve!'), 'warn')
        return
      }
      
      let gbn = ''
      if(this.custCd === '14017' || this.custCd === '12994'){
        gbn = 'v80a1040_new.jrxml'
        const param = {
          fileName: gbn,
          as_ship_no: this.shipNo === 'All' ? '' : this.shipNo,
          as_kind_cd: !kindCd ? '' : kindCd,
          as_block: !this.block ? '' : this.block.toUpperCase(),
          as_qm_part: this.qmPart === 'Hull' ? 'H' : 'M',
          as_resp_cd: this.respCd,         
          as_ins_date: this.stDate,
          as_insp_div: !this.division.code ? '' : this.division.code,
          
        }
        console.log('param: ', param);  
        this.openLoading('searching')
        reportView(param)
            .finally(() => {
              this.endLoading()
            })

      }else {
        gbn = 'v80o1020_prt_app.jrxml'
        const param = {
          fileName: gbn,
          as_cust_cd: this.custCd,
          as_qm_part: this.qmPart === 'Hull' ? 'H' : 'M',
          as_ship_no: this.shipNo,
          as_st_date: dayjs(this.stDate).format('YYYY-MM-DD'),
          as_insp_div: !this.division.code ? '' : this.division.code,
          as_item_info:'',
          as_attend_insp: '0',
          as_kind_cd: !kindCd ? '' : kindCd,
          as_insp_loc: '',
          as_page_num: '1',
        }
        console.log('param1: ', param);  
        this.openLoading('searching')
        reportView(param)
            .finally(() => {
              this.endLoading()
            })
      }      
      
    
    },
    btnOutsideInsp() {
      this.$router.push({
        name: 'v80a1060'
      });
    },
    fileOpen(e) {
      this.popupData.reqDate = e.data.reqDate
      this.popupData.respCd = this.respCd
      this.popupData.shipNo = e.data.shipNo
      this.popupData.inspAct = e.data.inspAct
      this.popupData.custCd = this.custCd
      this.gridMainList.forEach(element => {
        if (e.data.id == element.id) {
          this.popupData.revNo = element.revNo
        }
      });
      this.showPop = true

    },
    onValueChanged(value, cellInfo) {
      // cellInfo.value = cellInfo.value === 'Y' ? 'N' : 'Y'
      cellInfo.component.cellValue(cellInfo.rowIndex, cellInfo.columnIndex, cellInfo.value === 'Y' ? 'N' : 'Y')
      if (cellInfo.value === 'N') {
        cellInfo.component.selectRows([cellInfo.row.key], true)
        cellInfo.component.selectRows([cellInfo.row.key + 1], true)
      } else {
        cellInfo.component.deselectRows([cellInfo.row.key], true)
        cellInfo.component.deselectRows([cellInfo.row.key + 1], true)
      }
    },
    onValueChanged2(value, cellInfo) {
      cellInfo.component.cellValue(cellInfo.rowIndex, cellInfo.columnIndex, cellInfo.value === 'Y' ? 'N' : 'Y')
    },
    onEditingStart(e) {
      if (e.column.dataField === 'reqDate' && Number(e.data.num) % 2 != 0) {
        e.cancel = true
      }
      if (e.column.dataField === 'reqTime' && Number(e.key) % 2 != 0) {
        e.cancel = true
      }
      /* if (e.column.dataField === 'inspAct' && Number(e.key) % 2 != 0) {
          e.cancel = true
      } */
      if (e.column.dataField === 'itemDesc' && Number(e.key) % 2 != 0) {
        e.cancel = true
      }
      if (e.column.dataField === 'lqcMember' && Number(e.key) % 2 == 0) {
        e.cancel = true
      }

      if (e.column.dataField === 'reqDate' && Number(e.key) % 2 == 0) {
        if (e.data.resYn === 'Y') {
          e.cancel = true
        }
      }
      if (e.column.dataField === 'lqcMember' && Number(e.key) % 2 != 0) {
        if (e.data.resYn === 'Y') {
          e.cancel = true
        }
      }
      if (e.column.dataField === 'reqTime' && Number(e.key) % 2 == 0) {
        if (e.data.resYn === 'Y') {
          e.cancel = true
        }
      }
      if (e.column.dataField === 'inspAct' && Number(e.key) % 2 == 0) {
        if (e.data.resYn === 'Y') {
          e.cancel = true
        }
      }
    },
    //cell merge ,color
    cellPrepared(e) {
      if (e.rowType === 'data') {
        e.cellElement.style.padding = '1px'
        e.cellElement.style.height = '30.78px'
        if (Number(e.rowIndex) % 2 == 0 && e.column.caption === 'Sel') {
          e.cellElement.setAttribute('rowspan', 2)
        } else if (Number(e.rowIndex) % 2 != 0 && e.column.caption === 'Sel') {
          e.cellElement.style.display = 'none'

        }

        if (e.column.caption === 'Result' && e.columnIndex === 11) {
          if (Number(e.rowIndex) % 2 != 0) {
            e.cellElement.setAttribute('colspan', 5)
            e.column.dataType = 'string'
            e.cellElement.innerText = e.value

            if (e.value) {
              if (e.value.substring(0, 1) === 'A') {
                e.cellElement.style.color = '#0000FF'
              } else {
                e.cellElement.style.color = '#FF0000'
              }
            }

          }
        } else if (e.column.caption === 'Result' && e.columnIndex != 11) {
          if (Number(e.rowIndex) % 2 != 0) {
            e.cellElement.style.display = 'none'
          }
        }

        if (e.column.caption === 'Remark' && e.columnIndex === 6 && Number(e.rowIndex) % 2 == 0) {
          if (e.data.qmYn === 'Y') {
            e.cellElement.style.backgroundColor = '#00FF00'
          }
        }

        if (e.column.dataField === 'lqcMember' && e.columnIndex === 8) {
          e.cellElement.setAttribute('colspan', 2)

        } else if (e.column.dataField === 'lqcMember2' && e.columnIndex === 9) {
          e.cellElement.style.display = 'none'
        }

        if (e.column.dataField === 'lqcMember' && e.columnIndex === 8 && Number(e.rowIndex) % 2 != 0) {
          e.cellElement.innerText = e.value
        }

        if (e.column.caption === 'Ship No' || e.column.caption === 'Block') {
          if (Number(e.rowIndex) % 2 == 0) {
            e.cellElement.setAttribute('rowspan', 2)
          } else {
            e.cellElement.style.display = 'none'
          }
        }

        if ((e.column.dataField === 'reqDate' || e.columnIndex === 1) && Number(e.rowIndex) % 2 === 0) {
          e.cellElement.classList.add('cancel-editable-cell')
        }
        if ((e.column.dataField === 'reqTime' || e.columnIndex === 2) && Number(e.rowIndex) % 2 === 0) {
          e.cellElement.classList.add('cancel-editable-cell')
        }
        /* if ((e.column.dataField === 'inspAct' || e.columnIndex === 6) && Number(e.rowIndex) % 2 === 0) {
            e.cellElement.classList.add('cancel-editable-cell')
        } */
        if ((e.column.dataField === 'itemDesc' || e.columnIndex === 6) && Number(e.rowIndex) % 2 === 0) {
          e.cellElement.classList.add('cancel-editable-cell')
        }
        if ((e.column.dataField === 'lqcMember' || e.columnIndex === 8) && Number(e.rowIndex) % 2 !== 0) {
          e.cellElement.classList.add('cancel-editable-cell')
        }

      } else if (e.rowType === 'header') {
        if (e.column.caption === 'LQC Member' && e.columnIndex === 8) {
          e.cellElement.setAttribute('colspan', 2)
        } else if (e.column.caption === 'LQC Member' && e.columnIndex === 9) {
          e.cellElement.style.display = 'none'
        }

        if (e.column.caption === 'Inspection Kind' && e.columnIndex === 4) {
          e.cellElement.setAttribute('colspan', 2)
        } else if (e.column.caption === 'Inspection Kind' && e.columnIndex === 5) {
          e.cellElement.style.display = 'none'
        }

        if (e.column.caption === 'Result' && e.columnIndex === 7) {
          e.cellElement.setAttribute('colspan', 5)
        } else if (e.column.caption === 'Result' && e.columnIndex !== 7) {
          e.cellElement.style.display = 'none'
        }

      }
    },
    request(e) {
      let filter = []
      filter = e.custCd.split(' : ')

      this.shipNo = e.shipNo
      this.custCd = filter[0]
      this.inspDiv = e.inspDiv
      this.qmPart = e.qcPart
      this.stDate = e.stDate
      this.getMainList()
    }
  }
}
</script>

<style lang="scss" scoped>
.subText {
  font-weight: bold;
  color: black;
}

$redBtn: #FF0000;

.setBtnColor::v-deep {
  [role=btnDelete] {
    .v-btn__content {
      div {
        color: #{$redBtn} !important;
      }

      i {
        color: #{$redBtn} !important;
      }
    }
  }
}
</style>
